export const PAGE_NODE = `
	uri
	title
	content
	slug
	adsType {
		summary
		type
		exampleurl
		date
		researchers
		headerimage {
			sourceUrl
			altText
		}
	}
	adsHierarchy {
		childPages
	}
	adsGuidance {
		status
	}
	adsScope {
		platform
	}
	parent {
		node {
			uri
			... on Page {
				title
				content
				slug
				adsType {
					summary
					type
					exampleurl
					date
					researchers
					headerimage {
						sourceUrl
						altText
					}
				}
				adsHierarchy {
					childPages
				}
				adsGuidance {
					status
				}
				adsScope {
					platform
				}
				parent {
					node {
						uri
						... on Page {
							adsHierarchy {
								childPages
							}
						}
					}
				}
				children(first: 999) {
					nodes {
						... on Page {
							uri
							title
							content
							slug
							menuOrder
							adsGuidance {
								status
							}
							adsScope {
								platform
							}
							adsType {
								headerimage {
									sourceUrl
									altText
								}
								summary
								type
								exampleurl
								date
								researchers
								studyreportlink
								meetingreportlink
								prototypelink
								researchtype
								researchproduct
							}
						}
					}
				}
			}
			... on Page {
				id
				title
			}
		}
	}
	children(first: 999) {
		nodes {
			... on Page {
				uri
				title
				content
				slug
				menuOrder
				adsGuidance {
					status
				}
				adsScope {
					platform
				}
				adsType {
					headerimage {
						sourceUrl
						altText
					}
					summary
					type
					exampleurl
					date
					researchers
					studyreportlink
					meetingreportlink
					prototypelink
					researchtype
					researchproduct
				}
			}
		}
	}
`;

export const POST_NODE = `
  date
  status
  title
  link
  slug
  categories {
      nodes {
          name
      }
  }
  isContentNode
  content
`;

export const MENU_ITEM_NODE = `
  label
  id
  parentId
  path
  adsMenu {
    icon
    isseparator
  }
  childItems(first: 999) {
    nodes {
      id
      label
      path
      adsMenu {
        icon
        isseparator
      }
    }
  }
`;

export const SEARCH_PAGE_NODE = `
	uri
	title
	content
	slug
	adsHierarchy {
		childPages
	}
	parent {
		node {
			uri
			... on Page {
				title
				adsHierarchy {
					childPages
				}
			}
		}
	}
`;
